export default {
  API_URL: process.env.REACT_APP_API_URL,
  TEXT_DUPLICATE: process.env.REACT_APP_TEXT_DUPLICATE,
};
